import { Checkbox, type CheckboxProps } from '@mantine/core';
import { CheckboxSelected } from '@/assets/svg/CheckboxSelected';
import { CheckboxUnselected } from '@/assets/svg/CheckboxUnselected';

type CheckboxRegister = {
  value: any;
  onChange: (value: any) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  error?: string | undefined;
};
type CheckboxFieldProps = CheckboxProps & {
  register?: CheckboxRegister;
};

const CheckboxIcon: CheckboxProps['icon'] = ({ className, indeterminate }) =>
  indeterminate ? (
    <CheckboxUnselected
      className={className}
      style={{
        height: '20px',
        width: '20px',
        padding: 0,
      }}
    />
  ) : (
    <CheckboxSelected
      className={className}
      style={{
        height: '20px',
        width: '20px',
        padding: 0,
      }}
    />
  );

export const CheckboxField = (props: CheckboxFieldProps) => (
  // <Checkbox {...props.register} checked={props.register.value} {...props} />
  <Checkbox
    {...(props.register && { ...props.register })}
    checked={props?.register?.value}
    {...props}
    indeterminate={Boolean(props?.register?.value)}
    icon={CheckboxIcon}
    transitionDuration={0}
    styles={(theme) => ({
      input: {
        borderRadius: props.radius ?? '2px',
        borderColor: theme.colors.dark[1],
        cursor: 'pointer',
      },
      icon: {
        borderRadius: '50%',
      },
    })}
  />
);

const CheckboxFormIcon: CheckboxProps['icon'] = ({ className, indeterminate }) =>
  !indeterminate ? (
    <CheckboxUnselected
      className={className}
      style={{
        height: '20px',
        width: '20px',
        padding: 0,
      }}
    />
  ) : (
    <CheckboxSelected
      className={className}
      style={{
        height: '20px',
        width: '20px',
        padding: 0,
      }}
    />
  );

export const CheckboxFormField = (props: CheckboxFieldProps) => (
  // <Checkbox {...props.register} checked={props.register.value} {...props} />
  <Checkbox
    {...(props.register && { ...props.register })}
    checked={props?.register?.value}
    {...props}
    indeterminate={Boolean(props?.register?.value)}
    transitionDuration={0}
    icon={CheckboxFormIcon}
    styles={(theme) => ({
      input: {
        borderRadius: props.radius ?? '2px',
        borderColor: theme.colors.dark[1],
        cursor: 'pointer',
      },
      icon: {
        borderRadius: '50%',
      },
    })}
  />
);
// Checkbox {...(register && { register })} checked={register.value} {...props} />
